/** FIREBASE ENVIRONMENT */
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_DATABASE_URL =
  process.env.REACT_APP_FIREBASE_DATABASE_URL;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SEND_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SEND_ID;
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID =
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

/** APPLICATION ENVIRONMENT */
export const NODE_ENV = process.env.NODE_ENV;
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME;
export const REQUESTER_NAME = process.env.REACT_APP_REQUESTER_NAME;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const URL_FIREBASE = process.env.REACT_APP_URL_FIREBASE;
export const API_KEY_FIREBASE = process.env.REACT_APP_API_KEY_FIREBASE;
export const URL_CHAT = process.env.REACT_APP_URL_CHAT;
export const URL_ATENDIMENTO = process.env.REACT_APP_URL_ATENDIMENTO;
export const URL_DOWNLOAD_MANAGER = process.env.REACT_APP_URL_DOWNLOAD_MANAGER;
export const URL_DOWNLOAD_APP_ANDROID =
  process.env.REACT_APP_URL_DOWNLOAD_APP_ANDROID;
export const URL_DOWNLOAD_APP_IOS = process.env.REACT_APP_URL_DOWNLOAD_APP_IOS;
export const URL_BLOG_HERO = process.env.REACT_APP_URL_BLOG_HERO;
export const URL_SSO = process.env.REACT_APP_URL_SSO;
export const URL_SITE_FS = process.env.REACT_APP_URL_SITE_FS;
export const URL_INSTAGRAM_HERO = process.env.REACT_APP_URL_INSTAGRAM_HERO;
export const URL_FACEBOOK_HERO = process.env.REACT_APP_URL_FACEBOOK_HERO;
export const URL_YOUTUBE_HERO = process.env.REACT_APP_URL_YOUTUBE_HERO;
export const URL_PORTAL_CLOUD = process.env.REACT_APP_URL_PORTAL_CLOUD;
export const URL_PORTAL_KASPERSKY = process.env.REACT_APP_URL_PORTAL_KASPERSKY;
export const URL_CODIGO_ETICA = process.env.REACT_APP_URL_CODIGO_ETICA;
export const URL_POLITICA_PRIVACIDADE_SUPORTE_DIGITAL =
  process.env.REACT_APP_URL_POLITICA_PRIVACIDADE_SUPORTE_DIGITAL;
export const URL_TERMOS_DE_USO_SUPORTE_DIGITAL =
  process.env.REACT_APP_URL_TERMOS_DE_USO_SUPORTE_DIGITAL;
export const URL_TERMOS_DE_USO_HERO =
  process.env.REACT_APP_URL_TERMOS_DE_USO_HERO;
export const URL_API_AGILITY = process.env.REACT_APP_URL_AGILITY;

/** APPLICATION ENVIRONMENT VIVO */
export const BRAND_NAME_VIVO = process.env.REACT_APP_BRAND_NAME_VIVO;
export const CLIENT_ID_VIVO = process.env.REACT_APP_CLIENT_ID_VIVO;
export const CLIENT_SECRET_VIVO = process.env.REACT_APP_CLIENT_SECRET_VIVO;
export const API_KEY_FIREBASE_VIVO =
  process.env.REACT_APP_API_KEY_FIREBASE_VIVO;
export const URL_PORTAL_CLOUD_VIVO =
  process.env.REACT_APP_URL_PORTAL_CLOUD_VIVO;

/** BRIZANET OAUTH2 ENVIRONMENTS */
export const BRIZANET_OAUTH_AUTHORIZE_URL =
  process.env.REACT_APP_BRIZANET_OAUTH_AUTHORIZE_URL;
export const BRIZANET_OAUTH_ACCESSTOKEN_URL =
  process.env.REACT_APP_BRIZANET_OAUTH_ACCESSTOKEN_URL;
export const BRIZANET_OAUTH_CUSTOMER_INFORMATION_URL =
  process.env.REACT_APP_BRIZANET_OAUTH_CUSTOMER_INFORMATION_URL;
export const BRIZANET_OAUTH_REDIRECT_URI =
  process.env.REACT_APP_BRIZANET_OAUTH_REDIRECT_URI;
export const BRIZANET_OAUTH_REPONSE_TYPE =
  process.env.REACT_APP_BRIZANET_OAUTH_REPONSE_TYPE;
export const BRIZANET_OAUTH_CLIENT_ID =
  process.env.REACT_APP_BRIZANET_OAUTH_CLIENT_ID;
export const BRIZANET_OAUTH_CLIENT_SECRET =
  process.env.REACT_APP_BRIZANET_OAUTH_CLIENT_SECRET;
export const BRIZANET_OAUTH_SCOPE = process.env.REACT_APP_BRIZANET_OAUTH_SCOPE;

/** CLOUD FUNCTION */
export const URL_CLOUD_FUNCTION = process.env.REACT_APP_URL_CLOUD_FUNCTION;
export const TOKEN_CLOUD_FUNCTION = process.env.REACT_APP_TOKEN_CLOUD_FUNCTION;

export const LINK_PROTEGE_HELP = process.env.REACT_LINK_PROTEGE_HELP;
export const URL_CLOUD_OI_SEGURANCA =
  process.env.REACT_APP_URL_CLOUD_OI_SEGURANCA;
